import React, { useEffect, useState } from "react";
import Menu from "./Menu";
import MenuDesktop from "./MenuDesktop";
import Footer from "./Footer";
import logo from "../static/img/et_r.png";
import SocialLinks from "./SocialLinks";
import Particles from "react-particles-js";
import $ from "jquery";


function clickHandler(e) {
  e.preventDefault();
  const href = this.getAttribute("href");
  const offsetTop = document.querySelector(href).offsetTop;
  window.scroll({
    top: offsetTop,
    behavior: "smooth",
  });
}

function scrollEfect(setHFixed) {
  const header = document.getElementById('intro');
  window.onscroll = function () {
    const scroll = document.documentElement.scrollTop || document.body.scrollTop;
    if (scroll > 105 && header && window.screen.width > 799) {
     header.classList.add('header_fixed');
     setHFixed(true)
    } else if (header && header.classList.contains('header_fixed')) {
      header.classList.remove('header_fixed');
      setHFixed(false);
    }
  }
}

function smothScroll() {
  const links = document.querySelectorAll("#menuDesktop li a");
  const linksM = document.querySelectorAll("#menu li a"); 
  for (const link of links) {
    link.addEventListener("click", clickHandler);
  }
  for (const linkM of linksM) {
    linkM.addEventListener("click", clickHandler);
  }
}

const styles = {
  intro: {
    width: "100%",
  },
  particles: {
    position: "absolute",
    top: 200,
    left: 0,
    zIndex: -1,
  },
};

const LayoutMini = ({ children, className }) => {

  const [hFixed, setHFixed] = useState(false)

  useEffect(() => {
    scrollEfect(setHFixed);
    smothScroll();
  }, [])

  $(function () {
    $('[data-toggle="tooltip"]').tooltip();
  });


  return (
    <>
      <div id="hero" className="hero--diagonal">
        <div id="capa">
          <div className="d-md-none">
            <Menu />
          </div>
          <header id="intro" className="header pl-xl-5">
            <div className="clearfix mt-xl-0">
              <img
                src={logo}
                alt="logo"
                className="logo float-left mb-5 mt-5 pt-5 pt-md-1 mt-md-0 mr-md-3"
              />
             
            </div>
            <div className="d-none d-md-block">
              <MenuDesktop />
            </div>
          </header>
          <section
            id="welcome"
            className="animate__animated animate__fadeIn container"
            style={styles.intro}
          >
            <div className="container">
              <div className="row justify-content-center align-items center">
                <div className="col-12 col-md-10">
                  <div className="text-center">
                    {/* <div className="profile-image mt-5 d-lg-none"></div> */}
                    <h2 className="mt-4 pt-5 pt-md-0 welcome__name text-white bold">Eduardo Talavera</h2>
                    <div id="text-welcome" className="mt-5 mt-md-3"></div>
                    <div className="mt-3">
                      <SocialLinks mini />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* <Particles
              className="particles_home d-none d-md-block"
              style={styles.particles}
            /> */}
          </section>
        </div>
      </div>
      <div className={className}>{children}</div>
     <div className="wabe_footer">
      <Footer />
     </div>
    </>
  );
};

export default LayoutMini;
